export enum Country {
  MEXICO = "MX",
  COLOMBIA = "CO",
}

export const SUPPORTED_COUNTRIES = [Country.MEXICO, Country.COLOMBIA];

export interface CountryConfig {
  requiresPostalCode: boolean;
  requiresStreetNumber: boolean;
  requiresAdditionalInfo: boolean;
  usesGoogleMapsAutocomplete: boolean;
  usesCityRegionMapping: boolean;
}

export const COUNTRY_CONFIG: Record<Country, CountryConfig> = {
  [Country.MEXICO]: {
    requiresPostalCode: true,
    requiresStreetNumber: true,
    requiresAdditionalInfo: true,
    usesGoogleMapsAutocomplete: true,
    usesCityRegionMapping: false,
  },
  [Country.COLOMBIA]: {
    requiresPostalCode: true,
    requiresStreetNumber: true,
    requiresAdditionalInfo: false,
    usesGoogleMapsAutocomplete: true,
    usesCityRegionMapping: true,
  },
};
